import Hyperlink from '@ingka/hyperlink';
import IngkaSwitch from '@ingka/switch';
import { InlineText, LegalText, Text } from 'Common';
import CONFIG from 'Config/settings';
import PropTypes from 'prop-types';
import React from 'react';
import { t } from 'Utils/localization/i18next';
import { processLink } from 'Utils/url/urlUtils';
import { strongTextFunction } from 'Utils/string/stringUtils';
import './SwitchControlled.scss';

const SwitchControlled = props => {
  const prefix = CONFIG.APP.STYLES_PREFIX;
  return (
    <React.Fragment>
      {props.findPotentialCustomerForm && (
        <Text marginTop="m" marginBottom="s" />
      )}
      <div
        className={props.hideSubText ? undefined : `${prefix}switch-container`}
      >
        <Text bold={true}>{t(props.title)}</Text>
        <IngkaSwitch
          id={`${props.formId}-${props.name}`}
          name={props.name}
          // Defines default state of the IkeaCheckbox.
          checked={props.value}
          // It is not possible to handle IkeaCheckbox as a "controlled"
          // input. A workaround is to use the "checked" prop and set a
          // new default state of the checkbox. Default state is only
          // considered when the component is mounting. Component remount
          // can be triggered by toggling the "key" prop.
          // key={`${props.formId}-${props.name}-${props.value}`}
          prefix={prefix}
          disabled={props.disabled}
          describedById={`${props.formId}-${props.name}-error`}
          onChange={props.onChange}
          label={
            props.hideSubText &&
            (props.value
              ? t('forms.subscription_on')
              : t('forms.subscription_off'))
          }
        />
        {props.extraTextMsg && <InlineText msg={t(props.extraTextMsg)} />}
        {props.name === 'allowSMS' && !props.hideSmsExplanation && (
          <div className={`${prefix}switch-container`}>
            <Text className={`${prefix}inline-text-container`}>
              {(
                <Text>
                  {strongTextFunction(
                    t(
                      'dashboard.communications.newsletter-section.allowSmsText'
                    )
                  )}{' '}
                  <Hyperlink
                    newWindow={true}
                    className={`${prefix}inline-text`}
                    text={`${t(
                      'dashboard.communications.newsletter-section.allowSmsTermsLink'
                    )}`}
                    url={processLink(props.termsConditionsLink)}
                  />
                  {`. ${t(
                    'dashboard.communications.newsletter-section.allowSmsViewText'
                  )} `}
                  <Hyperlink
                    newWindow={true}
                    className={`${prefix}inline-text`}
                    text={`${t(
                      'dashboard.communications.newsletter-section.allowSmsPrivacyLink'
                    )}`}
                    url={processLink(props.privacyPolicyLink)}
                  />
                  {'.'}
                </Text>
              ) || (
                <Text className={`${prefix}inline-text`}>
                  {`${t(
                    'dashboard.communications.newsletter-section.allowSmsText'
                  )} `}
                  <Hyperlink
                    newWindow={true}
                    className={`${prefix}inline-text`}
                    text={`${t(
                      'dashboard.communications.newsletter-section.allowSmsTermsLink'
                    )}`}
                    url={processLink(props.termsConditionsLink)}
                  />
                  {`. ${t(
                    'dashboard.communications.newsletter-section.allowSmsViewText'
                  )} `}
                  <Hyperlink
                    newWindow={true}
                    className={`${prefix}inline-text`}
                    text={`${t(
                      'dashboard.communications.newsletter-section.allowSmsPrivacyLink'
                    )}`}
                    url={processLink(props.privacyPolicyLink)}
                  />
                  {'.'}
                </Text>
              )}
            </Text>
          </div>
        )}
      </div>
      {props.findPotentialCustomerForm && <Text>{t(props.subtitle)}</Text>}
      {props.legalText && <LegalText props={props.legalPhraseKeys} />}
    </React.Fragment>
  );
};

SwitchControlled.propTypes = {
  formId: PropTypes.string,
  title: PropTypes.string,
  name: PropTypes.string,
  currentSwitch: PropTypes.string,
  label: PropTypes.string,
  labelBeforeLink: PropTypes.string,
  labelAfterLink: PropTypes.string,
  labelLink: PropTypes.string,
  labelLinkLineBreak: PropTypes.string,
  link: PropTypes.string,
  disabled: PropTypes.bool,
  extraTextMsg: PropTypes.string,
  className: PropTypes.string,
  value: PropTypes.bool,
  hideSmsExplanation: PropTypes.bool,
  margin: PropTypes.oneOf(['xs', 's', 'm', 'l', 'xl', '2xl']),
  marginTop: PropTypes.oneOf(['xs', 's', 'm', 'l', 'xl', '2xl']),
  marginBottom: PropTypes.oneOf(['xs', 's', 'm', 'l', 'xl', '2xl']),
  marginLeft: PropTypes.oneOf(['xs', 's', 'm', 'l', 'xl', '2xl']),
  marginRight: PropTypes.oneOf(['xs', 's', 'm', 'l', 'xl', '2xl']),
  onChange: PropTypes.func,
  termsConditionsLink: PropTypes.string,
  privacyPolicyLink: PropTypes.string,
  findPotentialCustomerForm: PropTypes.bool,
  subtitle: PropTypes.string,
  hideSubText: PropTypes.bool,
  legalText: PropTypes.bool,
  legalPhraseKeys: PropTypes.arrayOf(PropTypes.string)
};

SwitchControlled.defaultProps = {
  hideSmsExplanation: true,
  findPotentialCustomerForm: false,
  currentSwitch: 'default',
  hideSubText: true,
  legalText: false
};

export default SwitchControlled;
